export default "__VITE_ASSET__cTqWMpQx__"